import { useRef, type PropsWithChildren } from 'react'

import { useSuppressOthers } from '@/legacy/hooks/useSuppressOthers'

import { VisuallyHidden } from '../VisuallyHidden'

export type ScreenReaderNotifierProps = PropsWithChildren<{
  label: string
  enabled?: boolean
  silencedTrigger?: boolean
  tag?: 'span' | 'p'
  allowSuppressOtherElements?: boolean
}>

export const ScreenReaderNotifier = ({
  label,
  enabled = false,
  silencedTrigger = false,
  tag = 'span',
  children: NotificationComponent,
  allowSuppressOtherElements = true,
}: ScreenReaderNotifierProps) => {
  const screenReaderMessage = useRef<HTMLParagraphElement>(null)
  const shouldSuppressOtherElements = enabled && allowSuppressOtherElements
  const shouldSilenceTrigger = silencedTrigger ? 'polite' : 'assertive'
  useSuppressOthers([screenReaderMessage], shouldSuppressOtherElements)

  return (
    <>
      {enabled && NotificationComponent}
      <VisuallyHidden
        as={tag}
        aria-live={shouldSilenceTrigger}
        aria-atomic={enabled}
        ref={screenReaderMessage}
      >
        {enabled && label}
      </VisuallyHidden>
    </>
  )
}
